import { useRef, useEffect } from 'react';

/**
 * Pass a state-field produced by `useState` into this function, and this function will return whatever its value was
 * before the current render-cycle.
 *
 * This is a copy-paste from the React docs, but from an entry that has since been removed; React is pretty insistent
 * that you shouldn't need this.
 *
 * @deprecated Ideally the thing that updates state has enough information to decide what the new state will be!
 */
export default function usePrevious<T>(state: T): T | undefined {
    const ref = useRef<T>();

    useEffect(() => {
        ref.current = state;
    });

    return ref.current;
}
